import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { TIPO_PERFIL } from '@/constantes/usuarios.js'
import { config } from '@/firebase.js'
const db = firebase.firestore()
const storage = firebase.storage().ref()
var firebaseAlterno = null
var cargadorIndiceEmpleados = null

const store = {
  state: {
    indiceEmpleados: [],
    empleado: {},
  },
  getters: {
    // Indice Empleados
    indiceEmpleados(state) {
      return state.indiceEmpleados
    },
    empleado(state) {
      return state.empleado
    }
  },
  mutations: {
    // Indice Empleados
    ASIGNA_INDICE_EMPLEADOS(state, indice) {
      state.indiceEmpleados = indice
    },
    ASIGNA_EMPLEADO(state, empleado) {
      state.empleado = empleado
    },
  },
  actions: {
    // INICIO INDICES
    cargaIndiceEmpleados({ commit, getters }) {
      return new Promise((resolve, reject) => {
        if (getters.indiceEmpleados === null) {
          if (typeof cargadorIndiceEmpleados === 'function') {
            cargadorIndiceEmpleados()
          }
          cargadorIndiceEmpleados = null
        }
        if (cargadorIndiceEmpleados === null) {
          let docPath = db
            .collection(FS_COLLECTIONS.PIXAN)
            .doc('Empleados')
          cargadorIndiceEmpleados = docPath.onSnapshot(doc => {
            resolve()
            commit('ASIGNA_INDICE_EMPLEADOS', doc.data())
          })
        } else {
          resolve()
        }
      })
    },
    cargaEmpleado({ commit }, idEmpleado) {
      return new Promise((resolve, reject) => {
        let docPath = db
          .collection(FS_COLLECTIONS.EMPLEADOS)
          .doc(idEmpleado)
        docPath.get().then(doc => {
          commit('ASIGNA_EMPLEADO', doc.data())
          resolve(doc.data())
        })
      })
      //return cargadorEmpleado
    },
  
    agregarNuevoEmpleado({ state, getters, dispatch }, empleado) {
      return new Promise((resolve, reject) => {
        //console.log(empleado)

        if (firebaseAlterno === null) {
          firebaseAlterno = firebase.initializeApp(config, 'Alterno')
        }
        console.log('Franquicia en empleados: ' + getters.franquicia.id)
        // TODO: Manejo de diferentes errores
        console.log('firebase.app.length: ' + firebase.app.length)

        let dbAlterno = firebaseAlterno.firestore()
        firebaseAlterno
          .auth()
          .createUserWithEmailAndPassword(
            empleado.email,
            //'ABcs9fsnf8s8uf8uw98j38j!!'
            empleado.password
          )
          .then(() => {
            var user = firebaseAlterno.auth().currentUser
            //console.log("CONSOLA DE USUARIO")
            //console.log(user);
            //Se envia la verificacion al correo
            firebaseAlterno
              .auth()
              .sendPasswordResetEmail(user.email)
              .then(function() {
                empleado.franquicia = getters.franquicia.id
                empleado.id = user.uid

                let perfil = {
                  es_admin: false,
                  es_empleado: true,
                  id: user.uid,
                  id_corporativo: getters.corporativo.id,
                  tipo: 'Empleado'
                }
                dbAlterno
                  .collection(FS_COLLECTIONS.PERFILES)
                  .doc(user.uid)
                  .set(perfil)
                  .then(() => {
                    console.log('perfil creado: ' + user.uid)
                  })
                
                empleado.tipo = 'empleado'
                empleado.estatus_pago.fecha_pago = new Date();
                dbAlterno
                  .collection('Empleados')
                  .doc(user.uid)
                  .set(empleado)
                  .then(() => {
                    resolve(user.uid)
                  })
              })
              .catch(function(error) {
                console.log(
                  'ERROR enviando la verificacion al empleado' +
                    error.message
                )
                reject(error)
              })
          })
          .catch(error => {
            console.log('error creando empleado' + error.message)
            reject(error)
          })
      })
    },


    actualizarEmpleado({ state, dispatch }, empleado) {
      return new Promise((resolve, reject) => {
        db.collection('Empleados')
          .doc(empleado.id)
          .update(empleado)
          .then(() => {
            
            resolve()
          })
      })
    },
  
  } // FIN ACTIONS
}

export default store



// WEBPACK FOOTER //
// ./src/store/empleados/empleados.js